import { render, staticRenderFns } from "./quizz.vue?vue&type=template&id=a216a342&"
import script from "./quizz.vue?vue&type=script&lang=js&"
export * from "./quizz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports